var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossDrower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51673 15.9917C1.12445 16.0148 0.738662 15.8829 0.440712 15.6238C-0.146904 15.0258 -0.146904 14.06 0.440712 13.462L13.3076 0.44536C13.9187 -0.133189 14.8778 -0.101028 15.4497 0.517256C15.9668 1.07637 15.997 1.93573 15.5202 2.53049L2.57757 15.6238C2.28346 15.8791 1.90386 16.0108 1.51673 15.9917Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3685 15.9917C13.9709 15.99 13.5899 15.8304 13.3076 15.5471L0.440662 2.53044C-0.103734 1.88732 -0.0297201 0.919449 0.606007 0.368668C1.17341 -0.122889 2.01022 -0.122889 2.57757 0.368668L15.5202 13.3853C16.1313 13.964 16.1629 14.9342 15.5908 15.5524C15.568 15.577 15.5445 15.6007 15.5202 15.6238C15.2033 15.9026 14.7862 16.0358 14.3685 15.9917Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossDrower);
export default __webpack_public_path__ + "static/media/CrossDrower.99966f335201d26c889bf42ffef0dc45.svg";
export { ForwardRef as ReactComponent };